module.exports = __webpack_public_path__ + "img/pic4-0.4f62a45d.png";